import React from 'react'
import { Snackbar, IconButton, withStyles } from '@material-ui/core'
import { compose } from 'recompose'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SnackbarActionCreators from 'State/Store/Snackbar/SnackbarActionCreators'
import GlobalSnackbarStyles from './GlobalSnackbar.style'
import CloseIcon from '@material-ui/icons/Close'
import selectSnackbarStore from 'State/Store/Snackbar/SnackbarStore.selector'
import { SnackbarStore } from 'State/Store/Snackbar/SnackbarStore.reducer'

interface Props {
  autoHideDuration?: number,
}

interface InjectedProps {
  snackbarStore: SnackbarStore,
  classes: any,
  actions: {
    closeSnackbar: typeof SnackbarActionCreators.closeSnackbar,
  }
}

const GlobalSnackbar = (props: Props & InjectedProps) => {
  const {
    autoHideDuration = 6000,

    snackbarStore: {
      open,
      message,
    },
    classes,
    actions: {
      closeSnackbar,
    },
  } = props
  const handleClose = () => {
    closeSnackbar()
  }
  return (
    <Snackbar
      action={[
        <IconButton
          aria-label='Close'
          className={classes.close}
          color='inherit'
          key='close'
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
      autoHideDuration={autoHideDuration}
      message={message}
      onClose={handleClose}
      open={open}
    />
  )
}

export default compose<Props & InjectedProps, Props>(
  withStyles(themeCreateInjectableStyles(GlobalSnackbarStyles) as any, { withTheme: true }),
  connect(
    (state) => {
      return {
        snackbarStore: selectSnackbarStore(state),
      }
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          closeSnackbar: SnackbarActionCreators.closeSnackbar,
        },
        dispatch,
      ),
    }),
  ),
)(GlobalSnackbar)
